import Vue from 'vue'
import popInput from "../components/popInput";

Vue.component('popInput', popInput)
